import { STATUS_SANEAMENTO } from "@/constants/STATUS_SANEAMENTO";
import { TIPO_INSPECAO } from "@/constants/TIPO_INSPECAO";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { usePermissao } from "@/hooks/usePermissao";
import { IListaTermoNotificacao } from "@/interfaces/IListaTermoNotificacao";
import { EyeOutlined, FileAddOutlined, FormOutlined } from "@ant-design/icons";
import { Button, List, Space, Tooltip, Typography } from "antd";
import { useNavigate } from "react-router";

export function ItemListSaneamento({
  item,
}: {
  item: IListaTermoNotificacao["content"][number];
}) {
  const { isOnline } = useNetworkStatus();
  const { hasEnabledPermissao } = usePermissao();
  const navigate = useNavigate();

  const redirectToView = () => {
    navigate(`/termos-notificacao/plano-acao/visualizar/${item.id}`);
  };

  const redirectToNewPlanoAcao = () => {
    navigate(`/termos-notificacao/plano-acao/novo/${item.id}`);
  };

  const redirectToNewParecer = () => {
    navigate(`/termos-notificacao/plano-acao/parecer/${item.id}`);
  };

  return (
    <>
      <List.Item
        extra={
          <Space>
            <Typography.Text>{STATUS_SANEAMENTO[item.status]}</Typography.Text>

            <Tooltip title="Adicionar Plano de Ação" destroyOnHidden>
              <Button
                icon={<FormOutlined />}
                size="small"
                disabled={
                  !isOnline ||
                  item.status !== "EMITIDO" ||
                  !hasEnabledPermissao("TERMO_NOTIFICACAO_SANEAMENTO_CRIAR")
                }
                onClick={redirectToNewPlanoAcao}
              />
            </Tooltip>

            <Tooltip title="Adicionar Parecer" destroyOnHidden>
              <Button
                icon={<FileAddOutlined />}
                size="small"
                disabled={
                  !isOnline ||
                  item.status !== "PENDENTE_PARECER" ||
                  !hasEnabledPermissao("TERMO_NOTIFICACAO_PARECER_CRIAR")
                }
                onClick={redirectToNewParecer}
              />
            </Tooltip>

            <Tooltip title="Visualizar" destroyOnHidden>
              <Button
                size="small"
                icon={<EyeOutlined />}
                onClick={redirectToView}
                disabled={
                  !isOnline ||
                  item.status === "CANCELADO" ||
                  !hasEnabledPermissao(
                    "TERMO_NOTIFICACAO_SANEAMENTO_VISUALIZAR"
                  )
                }
              />
            </Tooltip>
          </Space>
        }
      >
        <List.Item.Meta
          title={
            <Typography.Text
              strong
              style={{
                opacity: item.status === "CANCELADO" ? 0.6 : 1,
              }}
            >
              Termo Notificação {item.numero}
            </Typography.Text>
          }
          description={
            <Typography.Text
              style={{
                color: "#8c8c8c",
                fontSize: 12,
              }}
            >
              Estabelecimento: {item.estabelecimento.numeroInspecao}-
              {TIPO_INSPECAO[item.estabelecimento.tipoInspecao]}-
              {item.estabelecimento.nome}
            </Typography.Text>
          }
        />
      </List.Item>
    </>
  );
}
